module.exports = __webpack_public_path__ + "static/media/menu.1cd77719.svg";